import { render, staticRenderFns } from "./CallInquiriesDashboard.vue?vue&type=template&id=0ed2bc59&scoped=true&"
import script from "./CallInquiriesDashboard.vue?vue&type=script&lang=js&"
export * from "./CallInquiriesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CallInquiriesDashboard.vue?vue&type=style&index=0&id=0ed2bc59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed2bc59",
  null
  
)

export default component.exports